var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notFound)?_c('not-found',{attrs:{"context":_vm.appState.sitecoreContext}}):(_vm.loading)?_c('route-loading'):_c('layout',{attrs:{"route":_vm.appState.routeData}})}
var staticRenderFns = []

export { render, staticRenderFns }